module.exports = __webpack_public_path__ + "static/img/7.3f3765f0.jpg";